// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2EdRM","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1IFmf"};